import { createSlice } from '@reduxjs/toolkit';
import api from 'services/api';
import jwt from 'jwt-decode';
import sessionCookies from 'utils/cookies/sessionCookies';

const initialState = {
  userRoles: [],
  userName: '',
  loadingUser: false,
  loadedUser: false,
  userLoadError: '',
};

export const currentUser = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    loadUserStart: (state) => {
      state.loadingUser = true;
      state.loadedUser = false;
    },
    loadUserComplete: (state) => {
      state.loadingUser = false;
      state.loadedUser = true;
    },
    loadUserFailed: (state, { payload }) => {
      const { error } = payload;
      state.loadingUser = false;
      state.loadedUser = false;
      state.userLoadError = error;
    },
    setUserRoles: (state, { payload }) => {
      const { userRoles, userName } = payload;
      state.userRoles = userRoles;
      state.userName = userName;
    },
    clearAuthorizationState: (state) => {
      state.userRoles = [];
      state.loadingUser = false;
      state.loadedUser = false;
      state.userLoadError = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  loadUserStart,
  loadUserComplete,
  loadUserFailed,
  setUserRoles,
  clearAuthorizationState,
} = currentUser.actions;

export default currentUser.reducer;

//Async Functions
export const retrieveUserRoles = (userName) => async (dispatch) => {
  dispatch(loadUserStart());

  try {
    // Try to get roles from API first
    try {
      const results = await api.user.getUserRole(userName);
      const { status, userRoles, error } = results;
      if (status === 'Success') {
        dispatch(setUserRoles({ userRoles, userName }));
        dispatch(loadUserComplete());
        return;
      }
    } catch (apiError) {
      console.warn('API call for user roles failed, using defaults:', apiError);
    }

    // Fallback: set default roles
    const defaultRoles = ['Originator']; // Default role for authenticated users
    dispatch(setUserRoles({ userRoles: defaultRoles, userName }));
    dispatch(loadUserComplete());
  } catch (error) {
    console.error('Error retrieving user roles:', error);
    dispatch(
      loadUserFailed({ error: error.message || 'Failed to load user roles' })
    );
  }
};
